/** Strings of the ideas pages and the "New Idea" dialog: `ideasEn` is the source, `ideasCs` must have the same keys. */
export const ideasEn = {
  idea: {
    title: "Ideas",
    subtitle: "Lightweight pre-issues. Promote good ones to a project work item.",
    newIdea: "New Idea",
    empty: "No ideas in this view.",
    by: "by {{name}}",
    suggestedFor: "suggested for {{project}}",
    backToIdeas: "← Back to ideas",
    description: "Description",
    noDescription: "No description.",
    promotedTo: "Promoted to",
    rejected: "Rejected",
    status: {
      open: "open",
      converted: "converted",
      rejected: "rejected",
    },
    tabs: {
      open: "Open",
      converted: "Converted",
      rejected: "Rejected",
      all: "All",
    },
    convert: {
      title: "Convert to work item",
      hint: "Creates a GitLab issue in the chosen project and links it back here.",
      project: "Project",
      pick: "— pick —",
      type: "Type",
      feature: "Feature",
      bug: "Bug",
      standalone: "Task (no code work)",
      hotfix: "Hotfix",
      submit: "Convert",
      converting: "Converting",
      done: "Idea converted to a work item",
      failed: "Convert failed",
      pickProject: "Pick a project to convert into",
      error: "Error",
    },
    reject: {
      title: "Reject",
      hint: "Mark the idea as not pursuing. Can be reopened later.",
      reason: "Reason",
      optional: "(optional)",
      placeholder: "Out of scope, duplicate, …",
      submit: "Reject idea",
      rejecting: "Rejecting",
      done: "Idea rejected",
      failed: "Reject failed",
    },
    reopen: {
      submit: "Reopen",
      reopening: "Reopening",
      done: "Idea reopened",
      failed: "Reopen failed",
    },
    dialog: {
      title: "New Idea",
      ideaTitle: "Title",
      titlePlaceholder: "One line summary",
      description: "Description",
      markdown: "(Markdown)",
      descriptionPlaceholder: "What's the idea? Why is it interesting?",
      project: "Suggested project",
      optional: "(optional)",
      noProject: "— No project —",
      noProjects: "No projects",
      cancel: "Cancel",
      saveOpen: "Save & open detail",
      save: "Save",
      saved: "Idea saved",
      saveFailed: "Failed to save idea",
      titleRequired: "Title is required",
    },
  },
};

export const ideasCs: typeof ideasEn = {
  idea: {
    title: "Nápady",
    subtitle: "Odlehčené předtikety. Dobré nápady povýšíš na tiket v projektu.",
    newIdea: "Nový nápad",
    empty: "V tomto zobrazení nejsou žádné nápady.",
    by: "autor: {{name}}",
    suggestedFor: "navrženo pro {{project}}",
    backToIdeas: "← Zpět na nápady",
    description: "Popis",
    noDescription: "Bez popisu.",
    promotedTo: "Povýšeno na",
    rejected: "Zamítnuto",
    status: {
      open: "otevřený",
      converted: "převedený",
      rejected: "zamítnutý",
    },
    tabs: {
      open: "Otevřené",
      converted: "Převedené",
      rejected: "Zamítnuté",
      all: "Všechny",
    },
    convert: {
      title: "Převést na tiket",
      hint: "Vytvoří issue v GitLabu ve vybraném projektu a propojí ho zpět sem.",
      project: "Projekt",
      pick: "— vyber —",
      type: "Typ",
      feature: "Funkce",
      bug: "Chyba",
      standalone: "Úkol (bez práce v kódu)",
      hotfix: "Hotfix",
      submit: "Převést",
      converting: "Převádím",
      done: "Nápad byl převeden na tiket",
      failed: "Převod se nepovedl",
      pickProject: "Vyber projekt, do kterého se má nápad převést",
      error: "Chyba",
    },
    reject: {
      title: "Zamítnout",
      hint: "Označí nápad jako nerealizovaný. Později ho jde znovu otevřít.",
      reason: "Důvod",
      optional: "(nepovinné)",
      placeholder: "Mimo rozsah, duplicita, …",
      submit: "Zamítnout nápad",
      rejecting: "Zamítám",
      done: "Nápad byl zamítnut",
      failed: "Zamítnutí se nepovedlo",
    },
    reopen: {
      submit: "Znovu otevřít",
      reopening: "Otevírám",
      done: "Nápad byl znovu otevřen",
      failed: "Znovuotevření se nepovedlo",
    },
    dialog: {
      title: "Nový nápad",
      ideaTitle: "Název",
      titlePlaceholder: "Shrnutí na jeden řádek",
      description: "Popis",
      markdown: "(Markdown)",
      descriptionPlaceholder: "Co je to za nápad? Proč je zajímavý?",
      project: "Navrhovaný projekt",
      optional: "(nepovinné)",
      noProject: "— Bez projektu —",
      noProjects: "Žádné projekty",
      cancel: "Zrušit",
      saveOpen: "Uložit a otevřít detail",
      save: "Uložit",
      saved: "Nápad uložen",
      saveFailed: "Nápad se nepodařilo uložit",
      titleRequired: "Název je povinný",
    },
  },
};
